import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import SavedSearchBox from "../containers/saved_search_box";
import CentralBlankTabMessage from "../../../shared_components/central_blank_tab_message";
import ResetButton from "../containers/reset_button";

export default (MainFilters, AdvancedFilters) => {
  class FilterBox extends React.Component {
    render () {
      const hideFilters = this.props.isLocked;
      const hideFilterWrapperClass = hideFilters ? "hidden" : "";

      const advancedSearchBoxClasses = {
        "col-lg-10": true,
        "advanced-search-box": true,
        hidden: !this.props.showAdvancedSearch || hideFilters
      };

      let lockOverlay;

      if (this.props.isLocked) {
        lockOverlay = <CentralBlankTabMessage doNotPullMessageUp={true} styles={{ color: "white" }}>
          <a className="btn btn-primary" onClick={this.props.returnToOverview}>Return to Overview to use filter controls</a>
        </CentralBlankTabMessage>;
      }

      if (this.props.saveSearchLoading) {
        lockOverlay = <CentralBlankTabMessage message="Loading saved search" showBackground={true} />;
      }

      const advancedCaretClasses = {
        fa: true,
        "fa-caret-up": !!this.props.showAdvancedSearch,
        "fa-caret-down": !this.props.showAdvancedSearch,
      };

      const classes = {
        "filter-box row": true,
        "expand-for-parameter-panel": this.props.showParametersPanel
      };

      return (
        <div className={classNames(classes)}>
          <div className={`col-lg-10 ${hideFilterWrapperClass}`}>
            <MainFilters />
          </div>

          <div className={`col-lg-2 saved-search-and-advanced-filters-column ${hideFilterWrapperClass}`}>
            <div style={{ marginBottom: "10px" }} className="row">
              <div className="col-lg-12">
                <ResetButton />
              </div>
            </div>
            <div className="row saved-search-row">
              <SavedSearchBox />
            </div>
            <div style={{ marginTop: "20px" }} className="advanced-filter-button-row">
              <a onClick={this.props.toggleAdvancedSearch} className="col-lg-12 btn btn-danger" style={{ width: "100%", height: "100%" }}>Advanced filters <i className={classNames(advancedCaretClasses)}></i></a>
            </div>
          </div>
          <div className={classNames(advancedSearchBoxClasses)}>
            <div className="row">
              <h3 className="col-lg-10" style={{color: "white"}}>Advanced filters</h3>
            </div>
            <AdvancedFilters />
          </div>
          {lockOverlay}
        </div>
      );
    }
  }

  FilterBox.propTypes = {
    showAdvancedSearch: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    saveSearchLoading: PropTypes.bool.isRequired,
    toggleAdvancedSearch: PropTypes.func.isRequired,
    showParametersPanel: PropTypes.bool.isRequired,
    returnToOverview: PropTypes.func.isRequired
  };

  return FilterBox;
};
